import React, { useEffect, useState } from 'react'
import { DatePicker, Space } from 'antd';
import CalenderCard from './CalenderCard';
// import MonthlyData from './MonthlyData';

const { RangePicker } = DatePicker

function MonthlyData({ data, selectedRangeOnboard, dateFormat,amount,contribution, setIsModalOpen }) {
    const [convertedData, setConvertedData] = useState({});
    const [filledDates, setFilledDates] = useState([])
    const [max, setMax] = useState(null)

    const fillMissingDatesWithZeroCount = (data) => {
        const filledData = [];
        const startDate = new Date(dateFormat(selectedRangeOnboard?.[0]?.$d));
        const endDate = new Date(dateFormat(selectedRangeOnboard?.[1]?.$d));
        let currentIndex = 0;

        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            const dateString = currentDate.toISOString().split('T')[0];
            const existingEntry = data.find(item => item.date === dateString);

            if (existingEntry) {
                filledData.push(existingEntry);
            } else {
                filledData.push({ count: 0, date: dateString, day: getDayName(currentDate.getDay()) });
            }

            currentDate.setDate(currentDate.getDate() + 1);
        }
       
        setFilledDates(filledData)
        return filledData;
    };

    const getDayName = (dayIndex) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return days[dayIndex];
    };


    useEffect(() => {
        if (data) {
            // const filledData = fillMissingDatesWithZeroCount(data);
            // //console.log(filledData)
            setFilledDates(data)
            convertData(data);
        }
    }, [data]);

    const convertData = (data1) => {
        const newData = {};
        const orderedDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        data1.forEach(item => {
            if (!newData[item?.day]) {
                newData[item?.day] = [];
            }
            newData[item?.day].push({ count: item?.count, date: item?.date });
        });

        const sortedData = Object.fromEntries(
            Object.entries(newData).sort(
                ([day1], [day2]) => orderedDays.indexOf(day1) - orderedDays.indexOf(day2)
            )
        );

        //console.log(sortedData)
        // setConvertedData(sortedData);
        const maxDate = findMaxDay(sortedData);
        setConvertedData(maxDate)
    };

    // const findMinimumDate = (data1) => {
    //     let minimumDate = null;
    //     let minimumDay=''
    //     for (const item of data1) {
    //         //console.log(item.date)
    //         const currentDate = new Date(item.date);
    //         //console.log(currentDate)
    //         if (!minimumDate || currentDate < minimumDate) {
    //             minimumDate = currentDate;
    //             minimumDay=item?.day
    //         }
    //     }
    //     // //console.log(item)
    //     //console.log(minimumDay)
    //     //console.log(minimumDate)
    //     return minimumDay;
    // };

    // const findMaxDate = (data1) => {
    //     let minimumDate = null;
    //     let minimumDay=''
    //     for (const item of data1) {

    //         const currentDate = new Date(item.date);

    //         if (!minimumDate || currentDate > minimumDate) {
    //             minimumDate = currentDate;
    //             minimumDay=item?.day
    //         }
    //     }
    //     //console.log(minimumDate)
    //     return minimumDay;
    // };

    const findDay = (date) => {

        // Create a new Date object from the input date string
        const dateObject = new Date(dateFormat(date));

        // Get the day of the week (0 for Sunday, 1 for Monday, ..., 6 for Saturday)
        const dayIndex = dateObject.getDay();

        // Define an array of day names
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        // Get the day name from the array based on the day index
        const dayName = days[dayIndex];

        return dayName
    }





    const findMaxDay = data1 => {
        let max = 0;
        let maxDay = '';

        let modified = data1

        maxDay = findDay(data?.[0]?.date);

        setMax(maxDay)
        //console.log(maxDay)
        if (maxDay === 'Mon') {
            modified = modified
        }
        if (maxDay === 'Tue' || maxDay === 'Wed' || maxDay === 'Thu' || maxDay === 'Fri' || maxDay === 'Sat' || maxDay === 'Sun') {
            if (data1?.Mon) {
                modified['Mon'] = [{ count: '', date: '' }, ...data1?.Mon]
            } else {
                modified['Mon'] = [{ count: '', date: '' }]
            }
        }
        if (maxDay === 'Wed' || maxDay === 'Thu' || maxDay === 'Fri' || maxDay === 'Sat' || maxDay === 'Sun') {
            if (data1?.Tue) {
                modified['Tue'] = [{ count: '', date: '' }, ...data1?.Tue]
            }
            else {
                modified['Tue'] = [{ count: '', date: '' }]
            }
        }
        if (maxDay === 'Thu' || maxDay === 'Fri' || maxDay === 'Sat' || maxDay === 'Sun') {
            if (data1?.Wed) {
                modified['Wed'] = [{ count: '', date: '' }, ...data1?.Wed]
            }
            else {
                modified['Wed'] = [{ count: '', date: '' }]
            }
        }
        if (maxDay === 'Fri' || maxDay === 'Sat' || maxDay === 'Sun') {
            if (data1?.Thu) {
                modified['Thu'] = [{ count: '', date: '' }, ...data1?.Thu]
            }
            else {
                modified['Thu'] = [{ count: '', date: '' }]
            }
        }
        if (maxDay === 'Sat' || maxDay === 'Sun') {
            if (data1?.Fri) {
                modified['Fri'] = [{ count: '', date: '' }, ...data1?.Fri]
            }
            else {
                modified['Fri'] = [{ count: '', date: '' }]
            }
        }
        if (maxDay === 'Sun') {
            if (data1?.Sat) {
                modified['Sat'] = [{ count: '', date: '' }, ...data1?.Sat]
            }
            else {
                modified['Sat'] = [{ count: '', date: '' }]
            }
        }

        //console.log(modified)

        const minDay = findDay(data?.[data?.length-1]?.date);

        //console.log(minDay)


        if (minDay === 'Sun') {
            modified = modified
        }
        if (minDay === 'Tue' || minDay === 'Wed' || minDay === 'Thu' || minDay === 'Fri' || minDay === 'Sat' || minDay === 'Mon') {
            if (modified?.Sun) {
                modified['Sun'] = [...modified?.Sun, { count: '', date: '' }]
            }
            else {
                modified['Sun'] = [{ count: '', date: '' }]
            }
        }
        if (minDay === 'Wed' || minDay === 'Thu' || minDay === 'Fri' || minDay === 'Tue' || minDay === 'Mon') {
            if (modified?.Sat) {
                modified['Sat'] = [...modified?.Sat, { count: '', date: '' }]
            }
            else {
                modified['Sat'] = [{ count: '', date: '' }]
            }
        }
        if (minDay === 'Thu' || minDay === 'Wed' || minDay === 'Tue' || minDay === 'Mon') {
            if (modified?.Fri) {
                modified['Fri'] = [...modified?.Fri, { count: '', date: '' }]
            }
            else {
                modified['Fri'] = [{ count: '', date: '' }]
            }
        }
        if (minDay === 'Wed' || minDay === 'Tue' || minDay === 'Mon') {
            if (modified?.Thu) {
                modified['Thu'] = [...modified?.Thu, { count: '', date: '' },]
            }
            else {
                modified['Thu'] = [{ count: '', date: '' }]
            }
        }
        if (minDay === 'Tue' || minDay === 'Mon') {
            if (modified?.Wed) {
                modified['Wed'] = [...modified?.Wed, { count: '', date: '' }]
            }
            else {
                modified['Wed'] = [{ count: '', date: '' }]
            }
        }
        if (minDay === 'Mon') {
            if (modified?.Tue) {
                modified['Tue'] = [...modified?.Tue, { count: '', date: '' }]
            }
            else {
                modified['Tue'] = [{ count: '', date: '' }]
            }
        }

        //console.log(modified)

        return modified
    };

    const handleMonthTotal=()=>{
      let total = 0
      convertedData[max]?.length > 0 && new Array(convertedData[max]?.length).fill(null).map((data, id) => {
          total=total+ handleTotal(convertedData, id)
      })

      return parseFloat(total)
    }


    const handleTotal = (data, id) => {
        // //console.log(data)s
        const mon = convertedData?.['Mon']?.[id]?.count ? convertedData['Mon'][id]?.count : 0
        const tue = convertedData?.['Tue']?.[id]?.count ? convertedData['Tue'][id]?.count : 0
        const wed = convertedData?.['Wed']?.[id]?.count ? convertedData['Wed'][id]?.count : 0
        const thu = convertedData?.['Thu']?.[id]?.count ? convertedData['Thu'][id]?.count : 0
        const fri = convertedData?.['Fri']?.[id]?.count ? convertedData['Fri'][id]?.count : 0
        const sat = convertedData?.['Sat']?.[id]?.count ? convertedData['Sat'][id]?.count : 0
        const sun = convertedData?.['Sun']?.[id]?.count ? convertedData['Sun'][id]?.count : 0
        return parseFloat(mon) + parseFloat(tue) + parseFloat(wed) + parseFloat(thu) + parseFloat(fri) + parseFloat(sat) + parseFloat(sun)
    }

    function getDaySuffix(day) {
        if (day >= 11 && day <= 13) {
            return "th";
        }
        switch (day % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    }
    function formatDateRange(startDate, endDate) {
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const startDay = parseInt(startDate?.split('-')?.[2]);
        const startMonth = months?.[parseInt(startDate?.split('-')?.[1]) - 1];

        const endDay = parseInt(endDate?.split('-')?.[2]);
        const endMonth = months?.[parseInt(endDate?.split('-')?.[1]) - 1];

        const startSuffix = getDaySuffix(startDay);
        const endSuffix = getDaySuffix(endDay);

        return `${startDay}${startSuffix} ${startMonth} - ${endDay}${endSuffix} ${endMonth}`;
    }

    const WeeklyStats = (data1, id) => {
        const start = convertedData?.['Mon']?.[id]?.date ? convertedData?.['Mon']?.[id]?.date : dateFormat(data?.[0]?.date)
        //console.log(data,'hello')
        const end = convertedData?.['Sun']?.[id]?.date ? convertedData?.['Sun']?.[id]?.date : data?.[data?.length-1]?.date
        return formatDateRange(start, end)
    }

    return (
        // <div>

        //     <div>
        //         <div>Weekly</div>
        //         <div>Mon</div>
        //         <div>Tues</div>
        //         <div>Wed</div>
        //         <div>Thur</div>
        //         <div>Fri</div>
        //         <div>Sat</div>
        //         <div>Sun</div>
        //         <div>Total</div>
        //     </div>

        <div>
            <div>
                {
                    convertedData[max]?.length > 0 && new Array(convertedData[max]?.length).fill(null).map((data, id) => (
                        <div className='calender-card weeklystat' >
                            <div >{WeeklyStats(convertedData, id)} </div>
                            <div> </div>
                        </div>
                    ))
                }

            </div>
            <div>
                {
                    convertedData?.Mon?.map((data, id) => (
                        <CalenderCard data={data}  amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen}/>
                    ))
                }

            </div>
            <div>
                {
                    convertedData?.Tue?.map((data, id) => (
                        <CalenderCard data={data}  amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen} />
                    ))
                }

            </div>
            <div>
                {
                    convertedData?.Wed?.map((data, id) => (
                        <CalenderCard data={data}  amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen} />
                    ))
                }

            </div>
            <div>
                {
                    convertedData?.Thu?.map((data, id) => (
                        <CalenderCard data={data} amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen} />
                    ))
                }

            </div>
            <div>
                {
                    convertedData?.Fri?.map((data, id) => (
                        <CalenderCard data={data} amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen} />
                    )) 
                }

            </div>
            <div>
                {
                    convertedData?.Sat?.map((data, id) => (
                        <CalenderCard data={data}  amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen} />
                    ))
                }

            </div>
            <div>
                {
                    convertedData?.Sun?.map((data, id) => (
                        <CalenderCard data={data}  amount={amount} contribution={contribution}  setIsModalOpen={setIsModalOpen} />
                    ))
                }

            </div>

            <div>
                {
                    convertedData[max]?.length > 0 && new Array(convertedData[max]?.length).fill(null).map((data, id) => (
                      <div className='calender-card' >
                      <div >{
                      (amount==='amount' ) ?new Intl.NumberFormat("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits:  Number.isInteger( handleTotal(convertedData, id))?0:1,
                          maximumFractionDigits:  Number.isInteger( handleTotal(convertedData, id))?0:1,
                        }).format(handleTotal(convertedData, id)) :
                      handleTotal(convertedData, id)} </div>
                      <div> </div>
                  </div>
                    ))
                }
            </div>

            

            <div  >
              <div className='calender-card' style={{ width:'100%',color:'black',fontWeight:'700'}}>
                 {(amount==='amount' ) ? new Intl.NumberFormat("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits:  Number.isInteger( handleMonthTotal())?0:1,
                          maximumFractionDigits:  Number.isInteger( handleMonthTotal())?0:1,
                        }).format( handleMonthTotal()) :handleMonthTotal()}
              </div>
            </div>

        </div>




    )
}

export default MonthlyData
